export default __webpack_public_path__ + "static/media/qpr.0249a211.svg";